
import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";

import { RootState } from "../../store";
import { debugData } from "../../utils/debugData";
import { isEnvBrowser } from "../../utils/misc";
import { useSocketEventOutsideRequest } from "../../hooks/useSocketEventOutsideRequest";

import { UserState, SET_PLAYERDATA } from "../../reducers/userReducer";
import { PermissionType, PlayerType, HardMoneyState, SET_HOUSEDATA } from "../../reducers/hardmoneyReducer";
import { UIState, SET_activeTab, SET_hidden } from "../../reducers/uiReducer";
//import UsageItem from "./UsageItem";

const HomeUsage: React.FC = () => {
    const dispatch = useDispatch();
    const uiData = useSelector((state: RootState) => state.ui);
    const playerData = useSelector((state: RootState) => state.user);
    const hardmoneyData = useSelector((state: RootState) => state.hardmoney);

    return (
        <div
            className="flexCenter"
            style={{
                width: "100%",
                height: "fit-content",
                //overflow: "hidden",
                boxSizing: "border-box",
                position: "relative",
                //sbackgroundColor: "orange",
                fontSize: "1.5vh",
                paddingTop: "2vh",
                flexDirection: "column",
            }}
        >
            <div
                style={{
                    height: "auto",
                    width: "100%",
                    padding: "1vh 0 3vh 0",
                    textAlign: "left",
                    fontSize: "2.5vh",
                    //backgroundColor: "red",
                    fontFamily: 'Oswald',
                    fontWeight: "500",
                }}
            >
                Home Usage
            </div>
                
            <div
                style={{
                    //backgroundColor: "gray",
                    height: "100%",
                    width: "100%",
                    //overflow: "auto",
                    display: "flex",
                    justifyContent: "flex-start",
                    alignItems: "flex-start",
                    boxSizing: "border-box",
                    //gap: "2.5vh",
                    flexDirection: "column",
                    //paddingBottom: "5vh",
                }}
            >
                {uiData.usageItems.map((usageData, index) => {
                    const currentUtility = hardmoneyData.utilityValues.find(utility => 
                        utility.id === usageData.usageID
                    );
                
                    if (!currentUtility || currentUtility) return;

                    return <></>
                        // <UsageItem
                        //     key={index}
                        //     name={usageData.usageName}
                        //     iconPre={usageData.usageIconPre}
                        //     iconName={usageData.usageIconName}
                        //     defined={usageData.defined}
                        //     color={usageData.usageColor}
                        //     filledAmount={currentUtility.amount}
                        //     totalAmount={currentUtility.total}
                        //     isDisabled={currentUtility.isDisabled}
                        // />
                    
                })}
            </div>
        </div>
    );
};

export default HomeUsage;
